import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section login-section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "login-card__title" }, "Авторизация в iLink (Служебный кабинет)", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Войти")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      class: "card login-card",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _withDirectives(_createVNode(_component_base_input, {
        modelValue: _ctx.phone,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
        label: "Телефон",
        prefix: "+7",
        light: "",
        autofocus: ""
      }, null, 8, ["modelValue"]), [
        [_directive_mask, '(###) ###-##-##']
      ]),
      _createVNode(_component_base_input, {
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
        "input-type": "password",
        label: "Пароль",
        light: "",
        class: "mb-1"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_button, {
        type: "primary",
        "html-type": "submit",
        filled: "",
        block: "",
        loading: _ctx.isLoading,
        disabled: !_ctx.isFormFilledCorrectly
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ], 32)
  ]))
}